export default __webpack_public_path__ + "static/media/book_diligence_b_guide.199912c6.png";